module.exports = __webpack_public_path__ + "static/media/ejecutivos.37f15b12.svg";